// src/api/axios.js
import axios from 'axios';

const baseURL = process.env.VUE_APP_API_BASE_URL + '/api/v1';
// const baseURL = 'https://stg-api.shooohei.com/api/v1';
// const baseURL = 'https://prod-api.shooohei.com/api/v1';
// const baseURL = 'https://stg-measure-report-mng-api.soei-planning.com/api/v1';
// const baseURL = 'https://measure-report-mng-api.soei-planning.com/api/v1';

const instance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

const saveRoleMappings = (responseData = {}) => {
  if (responseData.roles_by_system && typeof responseData.roles_by_system === 'object') {
    localStorage.setItem('userRolesBySystem', JSON.stringify(responseData.roles_by_system));
  } else {
    localStorage.removeItem('userRolesBySystem');
  }

  if (responseData.explicit_roles_by_system && typeof responseData.explicit_roles_by_system === 'object') {
    localStorage.setItem('userExplicitRolesBySystem', JSON.stringify(responseData.explicit_roles_by_system));
  } else {
    localStorage.removeItem('userExplicitRolesBySystem');
  }
};

const saveAuthHeaders = (headers = {}) => {
  const accessToken = headers['access-token'];
  const client = headers['client'];
  const uid = headers['uid'];

  if (accessToken && client && uid) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('client', client);
    localStorage.setItem('uid', uid);
  }
};

const saveSessionFromAuthResponse = (response) => {
  const responseData = response?.data?.data || {};

  localStorage.setItem('userId', responseData.id);
  localStorage.setItem('userName', responseData.name);
  localStorage.setItem('userEmail', responseData.email);
  localStorage.setItem('userRole', responseData.role);
  saveRoleMappings(responseData);
  saveAuthHeaders(response?.headers || {});
};

const clearSessionStorage = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('client');
  localStorage.removeItem('uid');
  localStorage.removeItem('userId');
  localStorage.removeItem('userName');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('userRole');
  localStorage.removeItem('userRolesBySystem');
  localStorage.removeItem('userExplicitRolesBySystem');
};

const isSystemAccessDenied = (error) => {
  if (error?.response?.status !== 403) return false;

  const data = error.response?.data || {};
  const firstError = Array.isArray(data.errors) ? data.errors[0] : null;
  const message = firstError || data.error || data.message;
  return typeof message === 'string' && message.includes('アクセス権限');
};

// ログインメソッド
export const login = (email, password) => {
  return instance.post('/auth/sign_in', { email, password })
    .then(response => {
      saveSessionFromAuthResponse(response);
      return response;
    });
};

// Billing -> Measure のログイン引き継ぎトークン消費
export const consumeSystemHandoff = (handoffToken) => {
  return instance.post('/auth/system_handoffs/consume', { handoff_token: handoffToken })
    .then(response => {
      saveSessionFromAuthResponse(response);
      return response;
    });
};

// Measure -> Billing のログイン引き継ぎトークン発行
export const createSystemHandoff = (targetClientSystem) => {
  return instance.post('/auth/system_handoffs', {
    target_client_system: targetClientSystem
  });
};

// ログアウトメソッド
export const logout = () => {
  return instance.delete('/auth/sign_out')
    .then(response => {
      clearSessionStorage();
      return response;
    });
};

// パスワードリセットメソッド
export const passwordUpdate = (passwordData) => {
  // const userId = localStorage.getItem('userId');
  const userId = passwordData.user_id;
  return instance.post(`/users/${userId}/password_update`, {user: passwordData});
};

// ユーザ情報API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
export const getUsers = (params = {}) => {
  return instance.get('/users', { params });
};

export const getUserRoleCatalog = () => {
  return instance.get('/users/role_catalog');
};

export const createUser = (userData) => {
  const dataToSend = {
    name: userData.name,
    email: userData.email,
    role: userData.role,
    roles_by_system: userData.roles_by_system,
    password: userData.password
  };
  return instance.post('/users', {user: dataToSend});
};

export const updateUser = (userId, userData) => {
  const dataToSend = {
    name: userData.name,
    email: userData.email,
    role: userData.role,
    roles_by_system: userData.roles_by_system
  };
  return instance.put(`/users/${userId}`, { user: dataToSend });
};

export const getUser = (userId) => {
  return instance.get(`/users/${userId}`);
};

export const deleteUser = (userId) => {
  return instance.delete(`/users/${userId}`);
};

export const restoreUser = (userId) => {
  return instance.put(`/users/${userId}/restore`);
};

export const exportUsersCsv = (params = {}) => {
  return instance.get('/users/csv_output', {
    params,
    responseType: 'blob'
  });
};

export const importUsersCsv = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return instance.post('users/csv_upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// ユーザ情報API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝


// 顧客情報API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
export const getCustomers = (params = {}) => {
  return instance.get('/m_customers', { params });
};

export const checkCustomerDuplicate = (name) => {
  return instance.get('/m_customers/duplicate_check', { params: { name } });
};

export const createCustomer = (customerData) => {
  const dataToSend = {
    customer_nm: customerData.customer_nm,
    customer_no: customerData.customer_no,
    postal_code: customerData.postal_code,
    prefecture: customerData.prefecture,
    city: customerData.city,
    other_address: customerData.other_address,
    tel_num: customerData.tel_num,
    fax: customerData.fax,
    president_nm: customerData.president_nm,
    billing_nm: customerData.billing_nm
  };
  return instance.post('/m_customers', {m_customer: dataToSend});
};

export const updateCustomer = (customerId, customerData, params = {}) => {
  const dataToSend = {
    customer_nm: customerData.customer_nm,
    customer_no: customerData.customer_no,
    postal_code: customerData.postal_code,
    prefecture: customerData.prefecture,
    city: customerData.city,
    other_address: customerData.other_address,
    tel_num: customerData.tel_num,
    fax: customerData.fax,
    president_nm: customerData.president_nm,
    billing_nm: customerData.billing_nm
  };
  return instance.put(`/m_customers/${customerId}`, { m_customer: dataToSend }, { params });
};

export const getCustomer = (customerId, params = {}) => {
  return instance.get(`/m_customers/${customerId}`, { params });
};

export const deleteCustomer = (customerId, params = {}) => {
  return instance.delete(`/m_customers/${customerId}`, { params });
};

export const restoreCustomer = (customerId, params = {}) => {
  return instance.put(`/m_customers/${customerId}/restore`, null, { params });
};

export const exportCustomersCsv = (params = {}) => {
  return instance.get('/m_customers/csv_output', {
    params,
    responseType: 'blob'
  });
};

export const importCustomersCsv = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return instance.post('m_customers/csv_upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// 顧客 + 建物の取得
export const getCustomersBuildings = () => {
  return instance.get('/m_customers/customers_and_buildings');
};

// PDF出力
export const generatePDFReport = () => {
  return instance.get('/pdfs/generate_report', {
    responseType: 'blob' // PDFファイルとしてレスポンスを取得するために必要
  });
};
// 顧客情報API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝


// 建物情報API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
export const getBuildings = (params = {}) => {
  return instance.get('/m_buildings', { params });
};

export const checkBuildingDuplicate = (name) => {
  return instance.get('/m_buildings/duplicate_check', { params: { name } });
};

export const createBuilding = (buildingData) => {
  const dataToSend = {
    m_customer_id: buildingData.m_customer_id,
    m_building_type_id: buildingData.m_building_type_id,
    building_nm: buildingData.building_nm,
    postal_code: buildingData.postal_code,
    prefecture: buildingData.prefecture,
    city: buildingData.city,
    other_address: buildingData.other_address,
    tel_num: buildingData.tel_num,
    contract_dt: buildingData.contract_dt,
    in_charge_nm: buildingData.in_charge_nm,
    in_charge_phone_num: buildingData.in_charge_phone_num,
    in_charge_email: buildingData.in_charge_email
  };
  return instance.post('/m_buildings', {m_building: dataToSend});
};

export const updateBuilding = (buildingId, buildingData, params = {}, customerUpdateFrom = null) => {
  const dataToSend = {
    m_customer_id: buildingData.m_customer_id,
    m_building_type_id: buildingData.m_building_type_id,
    building_nm: buildingData.building_nm,
    postal_code: buildingData.postal_code,
    prefecture: buildingData.prefecture,
    city: buildingData.city,
    other_address: buildingData.other_address,
    tel_num: buildingData.tel_num,
    contract_dt: buildingData.contract_dt,
    in_charge_nm: buildingData.in_charge_nm,
    in_charge_phone_num: buildingData.in_charge_phone_num,
    in_charge_email: buildingData.in_charge_email
  };
  const payload = { m_building: dataToSend };
  if (customerUpdateFrom) {
    payload.customer_update_from = customerUpdateFrom;
  }
  return instance.put(`/m_buildings/${buildingId}`, payload, { params });
};

export const getBuilding = (buildingId, params = {}) => {
  return instance.get(`/m_buildings/${buildingId}`, { params });
};

export const deleteBuilding = (buildingId, params = {}) => {
  return instance.delete(`/m_buildings/${buildingId}`, { params });
};

export const restoreBuilding = (buildingId, params = {}) => {
  return instance.put(`/m_buildings/${buildingId}/restore`, null, { params });
};

export const exportBuildingsCsv = (params = {}) => {
  return instance.get('/m_buildings/csv_output', {
    params,
    responseType: 'blob'
  });
};

export const importBuildingsCsv = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return instance.post('m_buildings/csv_upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 建物情報API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝


// 建物種別情報API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
export const getBuildingTypes = (params = {}) => {
  return instance.get('/m_building_types', { params });
};

export const checkBuildingTypeDuplicate = (name) => {
  return instance.get('/m_building_types/duplicate_check', { params: { name } });
};

export const createBuildingType = (buildingTypeData) => {
  const dataToSend = {
    building_type_nm: buildingTypeData.building_type_nm,
    sort_no: buildingTypeData.sort_no
  };
  return instance.post('/m_building_types', {m_building_type: dataToSend});
};

export const updateBuildingType = (buildingTypeId, buildingTypeData, params = {}) => {
  const dataToSend = {
    building_type_nm: buildingTypeData.building_type_nm,
    sort_no: buildingTypeData.sort_no
  };
  return instance.put(`/m_building_types/${buildingTypeId}`, { m_building_type: dataToSend }, { params });
};

export const getBuildingType = (buildingTypeId, params = {}) => {
  return instance.get(`/m_building_types/${buildingTypeId}`, { params });
};

export const deleteBuildingType = (buildingTypeId, params = {}) => {
  return instance.delete(`/m_building_types/${buildingTypeId}`, { params });
};

export const restoreBuildingType = (buildingTypeId, params = {}) => {
  return instance.put(`/m_building_types/${buildingTypeId}/restore`, null, { params });
};

export const exportBuildingTypesCsv = (params = {}) => {
  return instance.get('/m_building_types/csv_output', {
    params,
    responseType: 'blob'
  });
};

export const importBuildingTypesCsv = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return instance.post('m_building_types/csv_upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 建物種別情報API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝


// 測定機器情報API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
export const getDevices = (params = {}) => {
  return instance.get('/m_devices', { params });
};

export const createDevice = (deviceData) => {
  const dataToSend = {
    device_nm: deviceData.device_nm,
    manufacuturer: deviceData.manufacuturer,
    model_nm: deviceData.model_nm,
    serial_no: deviceData.serial_no,
    specification: deviceData.specification,
    price: deviceData.price,
    last_upd_dt: deviceData.last_upd_dt
  };
  return instance.post('/m_devices', {m_device: dataToSend});
};

export const updateDevice = (deviceId, deviceData) => {
  const dataToSend = {
    device_nm: deviceData.device_nm,
    manufacuturer: deviceData.manufacuturer,
    model_nm: deviceData.model_nm,
    serial_no: deviceData.serial_no,
    specification: deviceData.specification,
    price: deviceData.price,
    last_upd_dt: deviceData.last_upd_dt
  };
  return instance.put(`/m_devices/${deviceId}`, { m_device: dataToSend });
};

export const getDevice = (deviceId) => {
  return instance.get(`/m_devices/${deviceId}`);
};

export const deleteDevice = (deviceId) => {
  return instance.delete(`/m_devices/${deviceId}`);
};

export const restoreDevice = (deviceId) => {
  return instance.put(`/m_devices/${deviceId}/restore`);
};

export const exportDevicesCsv = (params = {}) => {
  return instance.get('/m_devices/csv_output', {
    params,
    responseType: 'blob'
  });
};

export const importDevicesCsv = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return instance.post('m_devices/csv_upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 測定機器情報API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝


// 測定種別情報API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
export const getMeasureTypes = (params = {}) => {
  return instance.get('/m_measure_types', { params });
};

export const createMeasureType = (MeasureTypeData) => {
  const dataToSend = {
    measure_type_nm: MeasureTypeData.measure_type_nm,
    sort_no: MeasureTypeData.sort_no
  };
  return instance.post('/m_measure_types', {m_measure_type: dataToSend});
};

export const updateMeasureType = (MeasureTypeId, MeasureTypeData) => {
  const dataToSend = {
    measure_type_nm: MeasureTypeData.measure_type_nm,
    sort_no: MeasureTypeData.sort_no
  };
  return instance.put(`/m_measure_types/${MeasureTypeId}`, { m_measure_type: dataToSend });
};

export const getMeasureType = (MeasureTypeId) => {
  return instance.get(`/m_measure_types/${MeasureTypeId}`);
};

export const deleteMeasureType = (MeasureTypeId) => {
  return instance.delete(`/m_measure_types/${MeasureTypeId}`);
};

export const restoreMeasureType = (MeasureTypeId) => {
  return instance.put(`/m_measure_types/${MeasureTypeId}/restore`);
};

export const exportMeasureTypesCsv = (params = {}) => {
  return instance.get('/m_measure_types/csv_output', {
    params,
    responseType: 'blob'
  });
};

export const importMeasureTypesCsv = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return instance.post('m_measure_types/csv_upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 測定種別情報API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝


// 相対湿度マトリクスAPI＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
export const getRelativeHumidityMatrixs = (params = {}) => {
  return instance.get('/m_relative_humidity_matrixs', { params });
};

export const getRelativeHumidityMatrix = (dry_wet_diff, wet_blub) => {
  const dataToSend = {
    dry_wet_diff: dry_wet_diff,
    wet_blub: wet_blub
  };
  return instance.post('/m_relative_humidity_matrixs/get_relative_humidity', { m_relative_humidity_matrix: dataToSend });
};

export const importRelativeHumidityMatrixsCsv = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return instance.post('m_relative_humidity_matrixs/csv_upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const exportRelativeHumidityMatrixsCsv = () => {
  return instance.get('/m_relative_humidity_matrixs/csv_output', {
    responseType: 'blob'
  });
};
// 相対湿度マトリクスAPI＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝


// 空気環境測定基準値API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
export const getMeasureStds = (params = {}) => {
  return instance.get('/m_measure_stds', { params });
};

export const createMeasureStd = (measureStdData) => {
  const dataToSend = {
    m_measure_type_id: measureStdData.m_measure_type_id,
    min_max_type: measureStdData.min_max_type,
    std_val: measureStdData.std_val
  };
  return instance.post('/m_measure_stds', {m_measure_std: dataToSend});
};

export const updateMeasureStd = (measureStdId, measureStdData) => {
  const dataToSend = {
    m_measure_type_id: measureStdData.m_measure_type_id,
    min_max_type: measureStdData.min_max_type,
    std_val: measureStdData.std_val
  };
  return instance.put(`/m_measure_stds/${measureStdId}`, { m_measure_std: dataToSend });
};

export const getMeasureStd = (measureStdId) => {
  return instance.get(`/m_measure_stds/${measureStdId}`);
};

export const deleteMeasureStd = (measureStdId) => {
  return instance.delete(`/m_measure_stds/${measureStdId}`);
};

export const exportMeasureStdsCsv = (params = {}) => {
  return instance.get('/m_measure_stds/csv_output', {
    params,
    responseType: 'blob'
  });
};

export const importMeasureStdsCsv = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return instance.post('m_measure_stds/csv_upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 空気環境測定基準値API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝


// 測定報告書API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
export const getMeasurementReports = (params = {}) => {
  return instance.get('/t_measurement_reports', { params });
};

// 建物の登録済み報告書一覧取得
export const getBuildingMeasurementReports = (customerId, buildingId, params = {}) => {
  return instance.get(`/t_measurement_reports/building_measure_reports/${customerId}/${buildingId}`, { params });
};

// 建物の修正中報告書一覧取得
export const getFixingBuildingMeasurementReports = (customerId, buildingId, params = {}) => {
  return instance.get(`/t_measurement_reports/fixing_building_measure_reports/${customerId}/${buildingId}`, { params });
};

// 建物の最新の報告書取得
export const getBuildingLatestMeasurementReport = (customerId, buildingId) => {
  return instance.get(`/t_measurement_reports/latest_measure_report/${customerId}/${buildingId}`);
};

export const createMeasurementReport = (measurement_reportData) => {
  const dataToSend = {
    m_customer_id: measurement_reportData.m_customer_id,
    m_building_id: measurement_reportData.m_building_id,
    user_id: measurement_reportData.user_id,
    measure_dt: measurement_reportData.measure_dt,
    rpt_company_nm: measurement_reportData.rpt_company_nm,
    rpt_company_address: measurement_reportData.rpt_company_address,
    rpt_company_address02: measurement_reportData.rpt_company_address02,
    regist_no: measurement_reportData.regist_no,
    weather: measurement_reportData.weather,
    area_point: measurement_reportData.area_point,
    measure_person: measurement_reportData.measure_person,
    assistant: measurement_reportData.assistant,
    sign_title_01: measurement_reportData.sign_title_01,
    sign_title_02: measurement_reportData.sign_title_02,
    book_regist_flg: measurement_reportData.book_regist_flg,
    dear_nm: measurement_reportData.dear_nm,
    special_comment: measurement_reportData.special_comment,
    internal_remarks: measurement_reportData.internal_remarks,
    other_measure_type: measurement_reportData.other_measure_type,
    other_measure_unit: measurement_reportData.other_measure_unit,
    used_devices: measurement_reportData.used_devices,
    work_places: measurement_reportData.work_places,
    sign_flg: measurement_reportData.sign_flg
  };
  return instance.post('/t_measurement_reports', {t_measurement_report: dataToSend});
};

// IES4解析（報告書本体は保存しない）
export const previewMeasurementReportIes4 = ({ file, customerId, buildingId } = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  if (customerId) formData.append('m_customer_id', customerId);
  if (buildingId) formData.append('m_building_id', buildingId);

  return instance.post('/t_measurement_reports/ies4_import_preview', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// IES4登録（仮登録／本登録）
export const commitMeasurementReportIes4 = ({
  file,
  customerId,
  buildingId,
  usedDevices,
  bookRegistFlg = 0,
  allowDuplicate = false,
  importToken,
  sourceFileSha256,
  importMode = 'create',
  targetReportId
} = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('used_devices', JSON.stringify(usedDevices || []));
  formData.append('book_regist_flg', bookRegistFlg);
  formData.append('allow_duplicate', allowDuplicate);
  if (customerId) formData.append('m_customer_id', customerId);
  if (buildingId) formData.append('m_building_id', buildingId);
  // 再取込時の取込区分（create: 新規登録 / update: 既存報告書の更新）
  formData.append('import_mode', importMode);
  if (importMode === 'update' && targetReportId) formData.append('target_report_id', targetReportId);
  // 二重送信・ファイル差し替えの検出用
  if (importToken) formData.append('import_token', importToken);
  if (sourceFileSha256) formData.append('source_file_sha256', sourceFileSha256);

  return instance.post('/t_measurement_reports/ies4_import_commit', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// IES4一括取込（システム管理者専用）ーーーーーーーーーーーーー

// 複数ファイルを解析・照合する（報告書は作らない）。session_id を渡すと既存セッションに追加する。
export const analyzeMeasurementReportIes4Bulk = ({ files, sessionId } = {}) => {
  const formData = new FormData();
  (files || []).forEach((file) => formData.append('files[]', file));
  if (sessionId) formData.append('session_id', sessionId);

  return instance.post('/t_measurement_reports/ies4_bulk_analyze', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getMeasurementReportIes4BulkSessions = () => (
  instance.get('/t_measurement_reports/ies4_bulk_sessions')
);

export const getMeasurementReportIes4BulkSession = (sessionId) => (
  instance.get(`/t_measurement_reports/ies4_bulk_sessions/${sessionId}`)
);

// マッピングCSVはExcelで編集するため、BOM付きのバイナリとして受け取る
export const downloadMeasurementReportIes4BulkMappingCsv = (sessionId, { all = false } = {}) => (
  instance.get(`/t_measurement_reports/ies4_bulk_sessions/${sessionId}/mapping_csv`, {
    params: { all },
    responseType: 'blob'
  })
);

export const applyMeasurementReportIes4BulkMapping = (sessionId, file) => {
  const formData = new FormData();
  formData.append('file', file);

  return instance.post(`/t_measurement_reports/ies4_bulk_sessions/${sessionId}/apply_mapping`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 登録は少数ずつ繰り返し呼ぶ。1リクエストを短く保ち、途中で切れても続きから再開できるようにする。
export const commitMeasurementReportIes4Bulk = (sessionId, { bookRegistFlg = 0, limit, afterEntryId } = {}) => {
  const payload = { book_regist_flg: bookRegistFlg };
  if (limit) payload.limit = limit;
  if (afterEntryId) payload.after_entry_id = afterEntryId;

  return instance.post(`/t_measurement_reports/ies4_bulk_sessions/${sessionId}/commit`, payload);
};

export const updateMeasurementReport = (measurement_reportId, measurement_reportData) => {
  const dataToSend = {
    m_customer_id: measurement_reportData.m_customer_id,
    m_building_id: measurement_reportData.m_building_id,
    user_id: measurement_reportData.user_id,
    measure_dt: measurement_reportData.measure_dt,
    rpt_company_nm: measurement_reportData.rpt_company_nm,
    rpt_company_address: measurement_reportData.rpt_company_address,
    rpt_company_address02: measurement_reportData.rpt_company_address02,
    regist_no: measurement_reportData.regist_no,
    weather: measurement_reportData.weather,
    area_point: measurement_reportData.area_point,
    measure_person: measurement_reportData.measure_person,
    assistant: measurement_reportData.assistant,
    sign_title_01: measurement_reportData.sign_title_01,
    sign_title_02: measurement_reportData.sign_title_02,
    book_regist_flg: measurement_reportData.book_regist_flg,
    dear_nm: measurement_reportData.dear_nm,
    special_comment: measurement_reportData.special_comment,
    internal_remarks: measurement_reportData.internal_remarks,
    other_measure_type: measurement_reportData.other_measure_type,
    other_measure_unit: measurement_reportData.other_measure_unit,
    used_devices: measurement_reportData.used_devices,
    work_places: measurement_reportData.work_places,
    sign_flg: measurement_reportData.sign_flg
  };
  return instance.put(`/t_measurement_reports/${measurement_reportId}`, { t_measurement_report: dataToSend });
};

export const getMeasurementReport = (measurement_reportId) => {
  return instance.get(`/t_measurement_reports/${measurement_reportId}`);
};

export const deleteMeasurementReport = (measurement_reportId) => {
  return instance.delete(`/t_measurement_reports/${measurement_reportId}`);
};

// PDF出力
export const generateMesurementReportPDF = (measurement_reportId) => {
  return instance.get(`/pdfs/${measurement_reportId}/generate_report`, {
    responseType: 'blob' // PDFファイルとしてレスポンスを取得するために必要
  });
};
// 測定報告書API＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝


// すべてのリクエストに認証ヘッダーを添付
instance.interceptors.request.use(config => {
  config.headers['X-Client-App'] = 'measure';

  const accessToken = localStorage.getItem('accessToken');
  const client = localStorage.getItem('client');
  const uid = localStorage.getItem('uid');

  if (accessToken && client && uid) {
    config.headers['access-token'] = accessToken;
    config.headers['client'] = client;
    config.headers['uid'] = uid;
  }

  return config;
}, error => {
  return Promise.reject(error);
});

// レスポンスインターセプター
// 応答から新しいトークンを取得して更新
instance.interceptors.response.use(response => {
  // トークン情報を応答ヘッダーから取得
  const accessToken = response.headers['access-token'];
  const client = response.headers['client'];
  const uid = response.headers['uid'];

  if (accessToken && client && uid) {
    // 新しいトークン情報をローカルストレージに保存
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('client', client);
    localStorage.setItem('uid', uid);
  }

  return response;
}, error => {
  // 401 Unauthorizedエラーの場合、ユーザーをログアウト処理
  if (error.response && (error.response.status === 401 || isSystemAccessDenied(error))) {
    clearSessionStorage();
    // ログインページへリダイレクト等
  }
  return Promise.reject(error);
});

export default instance;
